import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import PageHelmet from "./PageHelmet";
import PageNavigation from "./PageNavigation";
import PageFooter from "./PageFooter";

import * as styles from "./pages.module.scss";

function PageLayout(props) {
  const { children, className, title, description, image } = props;

  return (
    <div className={styles.page}>
      <PageHelmet title={title} description={description} image={image} />
      <PageNavigation />
      <div className={cx(styles.body, className)}>{children}</div>
      <div>
        <PageFooter />
      </div>
    </div>
  );
}

PageLayout.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  className: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  image: PropTypes.string,
};

PageLayout.defaultProps = {
  className: "",
  title: "",
  description: "",
  image: "",
};

export default PageLayout;
